exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page {\n    max-height: 100%;\n    /* flex-direction: column; */\n}\n.buttonContainer {\n    padding-bottom: 16px;\n}\n.container {\n    padding-top: 8px;\n    padding-bottom: 16px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align:center;\n        align-items:center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    min-width: 420px;\n}\n.line{\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.action-button {\n    padding: 4px;\n}\n::ng-deep .fc-center {\n    text-align: center;\n    margin-left: -3%;\n    margin-top: 1%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/scheduling/scheduling.component.css
// module id = ../../../../../src/app/scheduling/scheduling.component.css
// module chunks = main